import React from 'react';

import { getObjects, getObjectSizes } from '../helpers';
import type { ObjectData } from '../types';

import { BaseExplorer } from './base-explorer';

type ObjectExplorerProps = {
	testId?: string;
};

export function ObjectExplorer({ testId }: ObjectExplorerProps): React.JSX.Element {
	return (
		<BaseExplorer<ObjectData>
			testId={testId}
			isObjectTile={false}
			getObjects={getObjects}
			getSizes={getObjectSizes}
		/>
	);
}
